module.exports = __webpack_public_path__ + "static/media/sad.9d16b7f9.svg";